// axiosInstance.js
import axios from 'axios';
import { useStore } from '@martyrs/src/modules/core/views/store/core.store.js';
// Создаем один экземпляр axios
const $axios = axios.create({
  baseURL: process.env.API_URL,
  withCredentials: true,
});

// Токен запроса на сервере берётся из сессии стора этого запроса, а не из общих
// заголовков экземпляра: экземпляр один на процесс, а запросов в процессе много.
// Гость initialize() не вызывает (core.app.js:310-327 — только при cookies.user),
// значит и сброса заголовка на сервере не происходит никогда, и токен предыдущего
// человека уезжал бы в SSR-запросы гостя из onServerPrefetch (2026-09-07).
// Пустая сессия — заголовка нет вовсе. Все серверные потребители $axios живут
// внутри контекста запроса (стор-модули и компоненты), поэтому фолбэка нет:
// вызов вне als.run должен падать ошибкой useStore, а не ходить в API без токена.
$axios.interceptors.request.use(config => {
  if (typeof window !== 'undefined') return config;

  const token = useStore().core.state.session.token;

  if (token) config.headers['x-access-token'] = token;
  else delete config.headers['x-access-token'];

  // Язык — из инстанса vue-i18n этого запроса (core.app.js:92-115 кладёт его в
  // store.context, гард setLocale пишет туда же через $i18n.locale). Раньше язык
  // ехал общими заголовками экземпляра: замер 2026-09-07 на 40 параллельных
  // раундах /pricing + /en/pricing дал 40 страниц из 160 с тарифами на чужом
  // языке, последовательно — 0 из 80.
  // Языка нет (i18n не создан) — заголовка нет: API подставит свой default
  // (locale.middleware.js:16), угадывать за него нечего.
  if (useStore().context?.i18n?.global?.locale?.value) config.headers['X-Locale'] = useStore().context.i18n.global.locale.value;
  else delete config.headers['X-Locale'];

  return config;
});

// Функция для установки токена в заголовки. Заголовки экземпляра — состояние
// процесса, поэтому на сервере они не годятся (см. перехватчик выше): там токен
// живёт в сессии стора запроса, и запись сюда только протекала бы между людьми.
export function setAuthToken(token) {
  if (typeof window === 'undefined') return;

  if (token) {
    $axios.defaults.headers.common['x-access-token'] = token; // Устанавливаем токен в заголовок
  } else {
    delete $axios.defaults.headers.common['x-access-token']; // Удаляем токен из заголовка
  }
}

// Функция для установки языка в заголовки: сервер читает X-Locale.
// Только клиент: заголовки экземпляра — состояние процесса, а на сервере
// страницы разных языков рендерятся одновременно. Замер 2026-09-07: 40
// параллельных раундов /pricing + /en/pricing дали 40 страниц из 160 с
// тарифами на чужом языке (последовательно — 0 из 80). На сервере язык
// ставит перехватчик выше из i18n этого запроса.
export function setLocaleHeader(locale) {
  if (typeof window === 'undefined') return;

  if (locale) {
    $axios.defaults.headers.common['X-Locale'] = locale;
  } else {
    delete $axios.defaults.headers.common['X-Locale'];
  }
}

// Функция для получения текущего базового URL
export function getBaseURL() {
  return $axios.defaults.baseURL;
}

// Функция для изменения базового URL
export function setBaseURL(url) {
  $axios.defaults.baseURL = url;
}

export function resetBaseURL() {
  $axios.defaults.baseURL = process.env.API_URL;
}

export default $axios;